export default {
	validators: {
		'email': 'required_with:isPasswordResetByEmail|email',
		'mobile': 'required_without:isPasswordResetByEmail'
	},
	messages: {
		"required_with.email": "forgot_password_email_required",
		"email.email": "forgot_password_email_invalid",
		"required_without.mobile": "forgot_password_mobile_required"
	}
}